module.exports = __webpack_public_path__ + "files/cf1bcec135b519702406da907f342e4b.png";